<template>
  <div class="min-h-screen pb-5 flex align-items-center justify-content-center">
    <PrimevueCard  class="sm:w-6 md:w-4 lg:w-3">
      <template #title>
        <a href="/" class="flex align-items-center mb-5 text-gray-900 no-underline" style="width:230px">
          <img src="/img/pifema-logo-dark.svg" width="130">
          <span class="text-2xl ml-2 " style="padding-top: 0.2rem">SPOT</span>
        </a>
      </template>
      <!-- <template #subtitle ><div class="mb-3 border-solid border-1 surface-border"></div></template> -->
      <template #content>
          <form @submit.prevent="submitHandler" name="loginForm">
            <div class="field">
                <label for="loginEmail">Email</label>
                <InputText class="w-full"
                  :class="`${v$.email.$error ? 'bg-red-200' : ''}`"
                  :invalid="v$.email.$error"
                  v-model="email"
                  type="email"
                  name="email"
                  id="loginEmail"
                 >
                </InputText>
                <div
                      v-for="(error, index) of v$.email.$errors"
                      :key="index"
                      class="text-sm font-italic text-red-400"
                >
                  {{ error.$message }}
                </div>              
            </div>
            
            <div class="field">          
              <label for="loginEmail">Password</label>
              <InputText class="w-full"
                 :class="`${v$.password.$error ? 'bg-red-200' : ''}`"
                 :invalid="v$.password.$error"
                  v-model="password"
                  type="password"
                  name="password"
                  id="loginPassword"
                  >
              </InputText>
              <div
                    v-for="(error, index) of v$.password.$errors"
                    :key="index"
                    class="text-sm font-italic text-red-400"
              >
                {{ error.$message }}
              </div>              

            </div>
             <!-- <div class="mt-3 mb-3 border-solid border-1 surface-border"></div> -->
            <div class="mt-2 flex flex-wrap justify-content-center">
                <PrimevueButton type="submit" label="Prihlásiť sa" text raised />
            </div>
          </form>
      </template>
    </PrimevueCard>
    </div>
</template>
<script lang="ts">
//import TextInput from "@/components/forms/TextInput.vue";

//import FormTag from "@/components/forms/FormTag.vue";
import { store } from './store';
import Security from './security';
import router from "@/router";
import notie from 'notie/dist/notie';
import PrimevueButton from 'primevue/button';
import PrimevueCard from 'primevue/card';
import { email, required, helpers  } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

export default{
  name : 'LoginComponent',
  components:{
    //FormTag,
    //TextInput,
    PrimevueButton,
    PrimevueCard,
  },
  data(){
    return{
      email:"",
      password:"",
      store,
    }
  },
  setup () {
    return {
      v$: useVuelidate()
    }
  },
  validations () {
    return {
      email: { email: helpers.withMessage('Nesprávny email', email)},
      password: { required: helpers.withMessage('Heslo musí byť vyplnené', required)},
    }
  },
  methods:{
    async submitHandler(){
      //console.log('submitHandler called - OK');
      const result = await this.v$.$validate()
      if (!result) {
        // notify user form is invalid
        return
      }
      // nastavime data ako payload
      const payload = {
        email: this.email,
        password : this.password
      }

      // odosleme login data

      fetch(store.Api_url+'/login', Security.requestOptions("POST",payload))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error){
              //console.log("Error:", responseData.message)
              notie.alert({
                type: 'error',
                text: responseData.message
              })
            }else{
              // console.log(responseData)
              if (typeof responseData.data.token != "undefined"){
                // premenna store, nacitane cez store.js, je globalna kniznica pre ukladanie globalnych premennych.
                // Tieto globalne premenne je mozne menit z akehokolvek componentu

                //console.log("User:", responseData.data)
                store.token = responseData.data.token.token
                store.user = {
                  id: responseData.data.user.id,
                  firstName:responseData.data.user.firstName,
                  lastName:responseData.data.user.lastName,
                  company:responseData.data.user.company,
                  email:responseData.data.user.email,
                  admin:responseData.data.user.admin,
                  department: responseData.data.user.department,
                }
                store.admin = responseData.data.admin
                store.selectModul = ""
                
                notie.alert({
                  type: 'success',
                  text: "Úspešné prihlásenie",
                  position: "bottom"
                })

                // ulozime token do cookie
                let date = new Date()
                let expDays = 1;

                date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000 ));
                const expires = "expires="+date.toUTCString();

                document.cookie = "_e-firma_data="
                    + JSON.stringify(responseData.data)
                    + ";"
                    + expires
                    + "; path=/; SameSite=strict; Secure;"

                router.push('/')
              }
            }
          })
    }
  }
}
</script>

<style scoped>
.min-h-screen {
  min-height: 98vh !important;
}
</style>